function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Announcement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Button = require("../Button");
var _CategoryPill = require("../CategoryPill");
var _Text = require("../Text");
var Icons = _interopRequireWildcard(require("../Icons"));
var _View = require("../View");
var _useLang = require("./useLang");
var _styles = require("../../styles");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Announcement = exports.Announcement = (0, _react.memo)(function (_ref) {
  var body = _ref.body,
    containerStyle = _ref.containerStyle,
    onRead = _ref.onRead,
    id = _ref.id,
    category = _ref.category,
    primaryActionLabel = _ref.primaryActionLabel,
    primaryActionOnPress = _ref.primaryActionOnPress,
    primaryActionLink = _ref.primaryActionLink,
    backgroundColor = _ref.backgroundColor,
    Image = _ref.Image,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? true : _ref$closeable;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    bp = _STYLES$useStyles.bp;
  var _hasActionButton = !!primaryActionLabel && (!!primaryActionOnPress || !!primaryActionLink);
  var _hasBackgroundColor = !!backgroundColor;
  var _hasImage = !!Image && bp.is([bp.tablet, bp.desktop]);
  var _hasOnRead = !!onRead;
  var _onRead = function _onRead() {
    onRead == null ? void 0 : onRead(id);
  };
  var _primaryActionOnPress = function _primaryActionOnPress() {
    primaryActionOnPress == null ? void 0 : primaryActionOnPress(id);
  };
  if (!id) return null;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.announcement, containerStyle, _hasBackgroundColor && {
      backgroundColor: backgroundColor
    }, _hasImage && styles.announcement_image],
    testID: "Announcement",
    children: [(0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.announcementRow,
      children: [(0, _jsxRuntime.jsxs)(_View.View, {
        style: styles.announcementContent,
        children: [(0, _jsxRuntime.jsx)(_View.View, {
          style: styles.announcementHeader,
          children: (0, _jsxRuntime.jsx)(_CategoryPill.CategoryPill, {
            backgroundColor: COLORS.studio,
            label: category || t('announcements:categoryPill')
          })
        }), (0, _jsxRuntime.jsx)(_Text.Text, {
          containerStyle: styles.textContainer,
          textStyle: styles.text,
          children: body
        }), _hasActionButton && (0, _jsxRuntime.jsx)(_Button.Button, {
          type: _Button.ButtonType.brand,
          label: primaryActionLabel,
          onPress: primaryActionOnPress ? _primaryActionOnPress : undefined,
          href: primaryActionLink,
          containerStyle: styles.primaryActionContainer,
          textStyle: styles.primaryActionLabel,
          size: _Button.ButtonSize.small
        })]
      }), _hasImage && (0, _jsxRuntime.jsx)(Image, {
        style: styles.announcementBackground,
        testID: "AnnouncementImage"
      })]
    }), closeable && (0, _jsxRuntime.jsx)(_Button.Button, {
      hideLabel: true,
      icon: Icons.Close,
      iconColor: COLORS.aubergine,
      label: t('announcements:button'),
      onPress: _hasOnRead ? _onRead : undefined,
      type: _Button.ButtonType.blank,
      containerStyle: styles.announcementCloseContainer,
      textStyle: styles.announcementClose,
      iconContainerStyle: styles.announcementCloseIconContainer
    })]
  });
});